var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotSupported = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C4.34375 0 2.92969 0.585938 1.75781 1.75781C0.585938 2.92969 0 4.34375 0 6C0 7.65625 0.585938 9.07031 1.75781 10.2422C2.92969 11.4141 4.34375 12 6 12C7.65625 12 9.07031 11.4141 10.2422 10.2422C11.4141 9.07031 12 7.65625 12 6C12 4.34375 11.4141 2.92969 10.2422 1.75781C9.07031 0.585938 7.65625 0 6 0ZM1.00781 6C1.00781 4.625 1.49609 3.44922 2.47266 2.47266C3.44922 1.49609 4.625 1.00781 6 1.00781C7.23438 1.00781 8.28125 1.39062 9.14062 2.15625L2.15625 9.14062C1.39062 8.28125 1.00781 7.23438 1.00781 6ZM6 10.9922C4.76562 10.9922 3.71875 10.6094 2.85938 9.84375L9.84375 2.85938C10.6094 3.71875 10.9922 4.76562 10.9922 6C10.9922 7.375 10.5039 8.55078 9.52734 9.52734C8.55078 10.5039 7.375 10.9922 6 10.9922Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotSupported);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/not-supported.e0a53c857182be511745d018e2bf8a1f.svg";